/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * CPA記録信頼度
 */
export type TreatmentCPADataConfidenceTypeEnum =
  (typeof TreatmentCPADataConfidenceTypeEnum)[keyof typeof TreatmentCPADataConfidenceTypeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TreatmentCPADataConfidenceTypeEnum = {
  ESTIMATED: 'ESTIMATED',
  CONFIRMED: 'CONFIRMED',
  UNKNOWN: 'UNKNOWN',
} as const;
